/* unplugin-vue-components disabled */import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.join.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.join.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    showRemove: {
      type: Boolean,
      default: false
    },
    lrmargin: {
      type: String,
      default: '0.76'
    },
    tbmargin: {
      type: String,
      default: '0.72'
    },
    list: Array,
    default: function _default() {
      return [];
    }
  },
  methods: {
    // 将16进制转为rgba
    hexToRgba: function hexToRgba(hex, opacity) {
      var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
      if (hex && reg.test(hex)) {
        // 若为#FFF之类的4位色值 先转换成6位色值
        if (hex.length === 4) {
          var hexNew = '#';
          for (var i = 1; i < 4; i++) {
            hexNew += hex.slice(i, i + 1).concat(hex.slice(i, i + 1));
          }
          hex = hexNew;
        }
        // 处理6位色值 生成rgba
        var rgba = [];
        for (var _i = 1; _i < 7; _i += 2) {
          rgba.push(parseInt('0x' + hex.slice(_i, _i + 2)));
        }
        return "rgba(".concat(rgba.join(','), ", ").concat(opacity, ")");
      }
    },
    removeTag: function removeTag(tagid) {
      this.$emit('remove', tagid);
    }
  }
};